import { Tag, Tooltip } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button, Popconfirm, Space } from 'antd';

const headerTitle = (label, full) =>
  full && full !== label ? (
    <Tooltip title={full}>
      <span>{label}</span>
    </Tooltip>
  ) : (
    label
  );

export function getWhatsAppGroupsColumns({ canEdit, onEdit, onDelete }) {
  return [
    {
      title: 'Group name',
      dataIndex: 'group_name',
      key: 'group_name',
      width: 220,
      render: (text) => (
        <span className="whitespace-nowrap font-semibold text-gray-800" title={text}>
          {text}
        </span>
      ),
    },
    {
      title: headerTitle('WA group ID', 'WhatsApp group ID'),
      dataIndex: 'whatsapp_group_id',
      key: 'whatsapp_group_id',
      width: 160,
      ellipsis: true,
      render: (text) => (
        <span className="whitespace-nowrap font-mono text-xs text-gray-600" title={text}>
          {text}
        </span>
      ),
    },
    {
      title: 'Partner',
      key: 'partner_id',
      width: 200,
      render: (_, record) => {
        const partner = record.partner;
        if (!record.partner_id || !partner) return <span className="text-gray-400">—</span>;
        return (
          <span
            className="whitespace-nowrap text-sm text-gray-700"
            title={partner.email || partner.mobile || partner.name}
          >
            {partner.name}
          </span>
        );
      },
    },
    {
      title: 'RM',
      key: 'assigned_rm',
      width: 160,
      render: (_, record) => {
        const rm = record.assigned_rm;
        if (!rm?.name) return <span className="text-gray-400">—</span>;
        return (
          <span
            className="whitespace-nowrap text-sm text-gray-700"
            title={rm.source === 'PARTNER' ? 'From partner mapping' : 'Manually assigned'}
          >
            {rm.name}
          </span>
        );
      },
    },
    {
      title: 'Active',
      dataIndex: 'is_active',
      key: 'is_active',
      width: 90,
      render: (v) => (
        <Tag color={v ? 'green' : 'default'}>{v ? 'Yes' : 'No'}</Tag>
      ),
    },
    {
      title: 'Chatbot',
      dataIndex: 'chatbot_enabled',
      key: 'chatbot_enabled',
      width: 100,
      render: (v) => (
        <Tag color={v ? 'cyan' : 'default'}>{v ? 'Yes' : 'No'}</Tag>
      ),
    },
    {
      title: 'Price list',
      dataIndex: 'price_list_to_be_sent',
      key: 'price_list_to_be_sent',
      width: 100,
      render: (v) => (
        <Tag color={v ? 'blue' : 'default'}>{v ? 'Yes' : 'No'}</Tag>
      ),
    },
    {
      title: headerTitle('Special price', 'Special price approval'),
      dataIndex: 'special_pricing_approval_enabled',
      key: 'special_pricing_approval_enabled',
      width: 120,
      render: (v) => (
        <Tag color={v ? 'gold' : 'default'}>{v ? 'Yes' : 'No'}</Tag>
      ),
    },
    {
      title: headerTitle('RM price', 'RM price approval'),
      dataIndex: 'rm_price_approval_enabled',
      key: 'rm_price_approval_enabled',
      width: 100,
      render: (v) => (
        <Tag color={v ? 'orange' : 'default'}>{v ? 'Yes' : 'No'}</Tag>
      ),
    },
    {
      title: 'Bond deck',
      dataIndex: 'bond_deck_to_be_sent',
      key: 'bond_deck_to_be_sent',
      width: 100,
      render: (v) => (
        <Tag color={v ? 'purple' : 'default'}>{v ? 'Yes' : 'No'}</Tag>
      ),
    },
    {
      title: headerTitle('Inventory', 'Inventory position'),
      dataIndex: 'inventory_position_to_be_sent',
      key: 'inventory_position_to_be_sent',
      width: 100,
      render: (v) => (
        <Tag color={v ? 'orange' : 'default'}>{v ? 'Yes' : 'No'}</Tag>
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 160,
      fixed: 'right',
      render: (_, record) => (
        <Space size="small">
          {canEdit && (
            <Button
              type="default"
              size="small"
              icon={<EditOutlined />}
              onClick={() => onEdit(record)}
            >
              Edit
            </Button>
          )}
          {canEdit && (
            <Popconfirm
              title="Remove this WhatsApp group?"
              description="The registration will be soft-deleted."
              onConfirm={() => onDelete(record)}
              okText="Delete"
              okButtonProps={{ danger: true }}
            >
              <Button type="text" danger size="small" icon={<DeleteOutlined />}>
                Delete
              </Button>
            </Popconfirm>
          )}
        </Space>
      ),
    },
  ];
}

export const ACTIVE_FILTER_OPTIONS = [
  { value: '', label: 'All status' },
  { value: 'true', label: 'Active' },
  { value: 'false', label: 'Inactive' },
];

export const BOOL_FILTER_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'true', label: 'Yes' },
  { value: 'false', label: 'No' },
];

export const FEATURE_FILTERS = [
  { key: 'priceListFilter', param: 'price_list_to_be_sent', label: 'Price list' },
  { key: 'bondDeckFilter', param: 'bond_deck_to_be_sent', label: 'Bond deck' },
  { key: 'inventoryFilter', param: 'inventory_position_to_be_sent', label: 'Inventory' },
  { key: 'chatbotFilter', param: 'chatbot_enabled', label: 'Chatbot' },
];
